import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.colors.neutral[0],
      padding: 12,
    },
    icon: { flexShrink: 0 },
  }
})
